import * as React from 'react';
import playIcon from '@/assets/images/svg/play_icon.svg';
import videoAvatarOn from '@/assets/images/svg/video_avatar_on.svg';
import copyIcon from '@/assets/images/svg/copy_icon.svg';
import shareIcon from '@/assets/images/svg/share_icon.svg';
import rateIcon from '@/assets/images/svg/rate_icon.svg';
import badResponseIcon from '@/assets/images/svg/bad_response.svg';
import goodResponseIcon from '@/assets/images/svg/good_response.svg';

export const MockMessageActions: React.FC = () => (
  <div className='ml-2 mt-2 flex items-center gap-[30px]'>
    <div className='flex items-center gap-4'>
      <img src={playIcon} alt='Play' className='size-4 opacity-80' />
      <img src={videoAvatarOn} alt='Video' className='size-4 opacity-80' />
    </div>
    <div className='flex items-center gap-4'>
      <img src={copyIcon} alt='Copy' className='size-4 opacity-80' />
      <img src={shareIcon} alt='Share' className='size-4 opacity-80' />
    </div>
    <div className='flex items-center gap-4'>
      <img src={rateIcon} alt='Rate' className='size-4 opacity-80' />
      <img src={badResponseIcon} alt='Bad response' className='size-4 opacity-80' />
      <img src={goodResponseIcon} alt='Good response' className='size-4 opacity-80' />
    </div>
  </div>
);
